import React, { Component } from "react";
import { Card, Row, Col, Form, Container } from "react-bootstrap";
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import moment from 'moment'
import CommonLoader from "./loaderComponent/CommonLoader";

export default class SalaryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      currentJobTitle: null,
      falseRedirect: false,
      editRedirect: false,
      backRedirect: false,
      loading: true
    };
  }

  componentDidMount() {

    if (this.props.location.state) {
      console.log("pankaj", this.props.location.state)
      axios({
        method: 'get',
        url: 'users/' + this.props.location.state.selectedUser?.empid,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
        .then(res => {
          console.log("mono", res.data)
          this.setState({ user: res.data, loading: false }, () => {
            if (this.state.user.jobs) {
              this.state.user.jobs.map(job => {
                if (new Date(job.startDate).setHours(0) < new Date() && new Date(job.endDate).setHours(24) > new Date()) {
                  this.setState({ currentJobTitle: job.jobTitle, loading: false })
                }
              })
            }
          },
          )
        })
        .catch(err => {
          console.log(err)
          this.setState({ loading: false })
        })
    } else {
      this.setState({ falseRedirect: true, loading: false })
    }
  }

  onEdit = () => {
    this.setState({ editRedirect: true })
  }

  handleBackList = () => {
    this.setState({ backRedirect: true })
  }

  render() {
    return (
      <Container className="pt-4">
        <CommonLoader isLoading={this.state.loading}>
          {this.state.falseRedirect ? <Redirect to="/" /> : (<></>)}
          {this.state.editRedirect ? (<Redirect to={{ pathname: "/salary-details", state: { selectedUser: this.state.user } }} />) : null}
          {this.state.backRedirect ? (<Redirect to={{ pathname: "/salary-list", }} />) : null}
          {this.state.user ? (
            <Row>
              <Col sm={12}>
                <Card>
                  <Card.Header style={{ backgroundColor: "#515e73", fontWeight: 700, color: "white", fontSize: '16px' }}>Employee Salary Detail
                    <Form className="float-right">
                      <div className="salary-view-navigation">
                        <span style={{ cursor: 'pointer' }} onClick={this.onEdit}>
                          <i className="far fa-edit"></i> Edit
                        </span>
                        <span style={{ cursor: 'pointer' }} onClick={this.handleBackList}>
                          <i className="far fa-arrow-alt-circle-right"></i> Back
                        </span>
                      </div>

                    </Form>
                  </Card.Header>
                  <Card.Body>
                    <Card.Title><strong>{this.state.user.fullName}</strong></Card.Title>
                    <Card.Text>
                      <Col lg={12}>
                        <Row className="pt-4">
                          <Col lg={3}>
                            <img className="img-circle elevation-1 bp-2" src={process.env.PUBLIC_URL + '/user-128.png'} alt="broken_profile"></img>
                          </Col>
                          <Col className="pt-4" lg={9}>
                            <div className="emp-view-list">
                              <ul className="employee-details">
                                <li>
                                  <span className="label">Employee ID:</span>
                                  <span className="value">{this.state.user.id}</span>
                                </li>
                                <li>
                                  <span className="label">Department:</span>
                                  <span className="value">{this.state.user?.department?.departmentName || "N/A"}</span>
                                </li>
                                <li>
                                  <span className="label">Job Title:</span>
                                  <span className="value">{this.state.currentJobTitle || "N/A"}</span>
                                </li>
                                <li>
                                  <span className="label">Role:</span>
                                  <span className="value">
                                    {this.state.user.role === 'ROLE_ADMIN' ? 'Admin' :
                                      this.state.user.role === 'ROLE_MANAGER' ? 'Manager' : 'Employee'}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </Col>

                        </Row>
                        <Row className="pt-4">
                          <Col sm={6}>
                            <Card className="secondary-card sal-view">
                              <Card.Header className="sal-header">Salary Details</Card.Header>
                              <Card.Body>
                                <Card.Text id="sal-view-details">
                                  <div className="salary-info">
                                    <div className="salary-item">
                                      <span className="label">Employment Type:</span>
                                      <span className="value">
                                        {this.state.user.user_financial_info?.employmentType || "N/A"}
                                      </span>
                                    </div>
                                    <div className="salary-item">
                                      <span className="label">Over Time (Hours):</span>
                                      <span className="value">
                                        {this.state.user.user_financial_info?.OtWorkingHours || "0"}
                                      </span>
                                    </div>
                                    <div className="salary-item">
                                      <span className="label">Basic Salary:</span>
                                      <span className="value">
                                        ₹ {this.state.user.user_financial_info?.salaryBasic || "0"}
                                      </span>
                                    </div>
                                    <div className="salary-item">
                                      <span className="label">Over Time Status(Hours):</span>
                                      <span className="value">
                                        {this.state.user.user_financial_info?.otStatus || ""}
                                      </span>
                                    </div>
                                    <div className="salary-item">
                                      <span className="label">ESIC Status:</span>
                                      <span className="value">
                                        {this.state.user.user_financial_info?.esicStatus || ""}
                                      </span>
                                    </div>

                                  </div>
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>

                          <Col sm={6}>
                            <Card className="secondary-card sal-view">
                              <Card.Header className="sal-header">Allowances</Card.Header>
                              <Card.Body>
                                <Card.Text id="sal-view-allowances">
                                  <div className="allowances-info">
                                    {[
                                      { label: "House Rent Allowance", key: "allowanceHouseRent" },
                                      { label: "Medical Allowance", key: "allowanceMedical" },
                                      { label: "Special Allowance", key: "allowanceSpecial" },
                                      { label: "Fuel Allowance", key: "allowanceFuel" },
                                      { label: "Phone Bill Allowance", key: "allowancePhoneBill" },
                                      { label: "Other Expenses", key: "allowanceOther" },
                                      { label: "Total Allowance", key: "allowanceTotal", isBold: true },
                                    ].map((item, index) => (
                                      <div className={`allowance-item ${item.isBold ? "total-allowance" : ""}`} key={index}>
                                        <span className="label">{item.label}:</span>
                                        <span className="value">
                                          ₹ {this.state.user.user_financial_info?.[item.key] || "0"}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>

                        </Row>
                        <Row>
                          <Col sm={6}>
                            <Card className="secondary-card ">
                              <Card.Header className="deduction-header">Deductions</Card.Header>
                              <Card.Body>
                                <Card.Text id="sal-view-deductions">
                                  <div className="deduction-info">
                                    {[
                                      { label: "Tax Deduction", key: "deductionTax" },
                                      { label: "Other Deduction", key: "deductionOther" },
                                      { label: "Total Deduction", key: "deductionTotal", isBold: true },
                                    ].map((item, index) => (
                                      <div className={`deduction-item ${item.isBold ? "total-deduction" : ""}`} key={index}>
                                        <span className="label">{item.label}:</span>
                                        <span className="value">
                                          ₹ {this.state.user.user_financial_info?.[item.key] || "0"}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>

                          <Col sm={6}>
                            <Card className="secondary-card ">
                              <Card.Header className="salary-header">Total Salary Details</Card.Header>
                              <Card.Body>
                                <Card.Text id="sal-view-total">
                                  <div className="salary-info">
                                    {[
                                      { label: "Gross Salary", key: "salaryGross" },
                                      { label: "Total Deduction", key: "deductionTotal" },
                                      { label: "Net Salary", key: "salaryNet", isBold: true },
                                    ].map((item, index) => (
                                      <div className={`salary-item ${item.isBold ? "net-salary" : ""}`} key={index}>
                                        <span className="label">{item.label}:</span>
                                        <span className="value">
                                          ₹ {this.state.user.user_financial_info?.[item.key] || "0"}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>

                        </Row>
                      </Col>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : null}
        </CommonLoader>
      </Container>
    );
  }
}